<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              <div>
                Tipo Actividad<select class="form-control" v-model="configuration.TIPO_ACTIVIDAD" @change="configuration.RESP_TIPO_REPRESENTACION=0">
                  <option value="1">1. Asociar número y cantidad</option>
                  <option value="2">2. Leer y escribir cantidades</option>
                  <option value="3">3. Identificar en una cifra el número que representa</option>
                  <option value="4">4. Definir en una cifra el valor posicional de uno de sus números en décimas</option>
                  <option value="5">5. Definir en una cifra el valor posicional de uno de sus números en centésimas</option>
                  <option value="6">6. Definir en una cifra el valor posicional de uno de sus números en milésimas</option>
                  <option value="7">7. Redondear una cifra por proximidad</option>
                  <option value="8">8. Equivalencia entre decimales y fracciones</option>
                  <option value="9">9. Descomposición númerica</option>
                </select>
              </div>
              <br/>
              <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_ACTIVIDAD)===9">
                <input type="checkbox" class="custom-control-input"
                  id="MOSTRAR_DESCOMPUESTO" v-model="configuration.MOSTRAR_DESCOMPUESTO">
                <label class="custom-control-label" for="MOSTRAR_DESCOMPUESTO">Mostrar Descompuesto</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                  id="INDICATIVO_UNIDAD" v-model="configuration.INDICATIVO_UNIDAD">
                <label class="custom-control-label" for="INDICATIVO_UNIDAD">Indicativo Unidad</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.AUDIO_POR_ACTIVIDAD"
                id="AUDIO_POR_ACTIVIDAD">
                <label class="custom-control-label" for="AUDIO_POR_ACTIVIDAD">Audio por actividad</label>
              </div>
              <div class="custom-control custom-checkbox" v-if="parseInt(configuration.TIPO_ACTIVIDAD)===8">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.SIMPLIFICAR_RESULTADO"
                id="SIMPLIFICAR_RESULTADO">
                <label class="custom-control-label" for="SIMPLIFICAR_RESULTADO">Simplificar resultado</label>
              </div>
          </div>
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Representaciones</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.ARABIGO"
                id="ARABIGO">
                <label class="custom-control-label" for="ARABIGO">Arábigo</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="verbaloral">
                <label class="custom-control-label" for="verbaloral">Verbal oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ESCRITO"
                id="VERBAL_ESCRITO">
                <label class="custom-control-label" for="VERBAL_ESCRITO">Verbal escrito</label>
              </div>
              <div v-if="parseInt(configuration.TIPO_ACTIVIDAD) !== 9">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                    id="REPRESENTACION_GRAFICA" v-model="configuration.REPRESENTACION_GRAFICA">
                  <label class="custom-control-label" for="REPRESENTACION_GRAFICA">Representación Gráfica</label>
                </div>
                <br/>
                    Tipo Representación<select class="form-control" v-model="configuration.TIPO_REPRESENTACION">
                      <option value="0">Cantidad</option>
                      <option value="2">Ábaco</option>
                    </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Respuestas</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                id="resarabigo" disabled checked>
                <label class="custom-control-label" for="resarabigo">
                  Respuesta Arábigo</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ORAL"
                id="respverbaloral">
                <label class="custom-control-label" for="respverbaloral">
                  Respuesta Verbal Oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ESCRITO"
                id="RESP_VERBAL_ESCRITO">
                <label class="custom-control-label" for="RESP_VERBAL_ESCRITO">Respuesta Verbal Escrita</label>
              </div>
              <div v-if="parseInt(configuration.TIPO_ACTIVIDAD) !== 9">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input"
                  v-model="configuration.RESP_REPRESENTACION_GRAFICA"
                  id="RESP_REPRESENTACION_GRAFICA">
                  <label class="custom-control-label" for="RESP_REPRESENTACION_GRAFICA">Respuesta Representación Gráfica</label>
                </div>
                <br/>
                  Respuesta Tipo Representación<select class="form-control" v-model="configuration.RESP_TIPO_REPRESENTACION">
                    <option value="0">Cantidad</option>
                    <option value="2" v-if="parseInt(configuration.TIPO_ACTIVIDAD) !== 8">Ábaco</option>
                  </select>
              </div>
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col style="text-align:center">
          <div class="d-inline" v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 8">
            <a href="https://www.hostmath.com/" target="_blank"><i class="zmdi zmdi-link" /> Editor de Latex</a>
            <b-button @click="bShowLatex = !bShowLatex" class="btn btn-warning ml-2 p-1" size="sm">Ver latex</b-button>
            <span class="mx-3">|</span>
          </div>
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row  class="justify-content-md-center">
          <b-col col lg="3" style="text-align:center"><h6>Cantidad</h6></b-col>
          <b-col md="3" style="text-align:center" v-if="bShowLatex"><h6>Visualización</h6></b-col>
          <b-col col lg="2" style="text-align:center"
          v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 3 || parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5
            || parseInt(configuration.TIPO_ACTIVIDAD) === 6 || parseInt(configuration.TIPO_ACTIVIDAD) === 7">
            <h6>Incógnita</h6>
          </b-col>
      </b-row>
      <div>
       <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="3">
                <ValidationProvider
                   :rules="{
                    required: true,
                    decimal: parseInt(configuration.TIPO_ACTIVIDAD) === 8 ? false : true}"
                    v-slot="{ errors }">
                  <b-form-input
                      :type="parseInt(configuration.TIPO_ACTIVIDAD) === 8 ? 'text' : 'number'"
                      v-bind:id="'CANTIDAD' + index"
                      v-model="arrayEleOperation[index].CANTIDAD"/>
                      <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="3" style="text-align:center" v-if="bShowLatex">
                <div v-katex="arrayEleOperation[index].CANTIDAD"></div>
              </b-col>
              <b-col col lg="2" v-if="parseInt(configuration.TIPO_ACTIVIDAD) === 3 || parseInt(configuration.TIPO_ACTIVIDAD) === 4 || parseInt(configuration.TIPO_ACTIVIDAD) === 5
                || parseInt(configuration.TIPO_ACTIVIDAD) === 6 || parseInt(configuration.TIPO_ACTIVIDAD) === 7">
                <ValidationProvider rules="required" v-slot="{ errors }">
                <select class="form-control" v-model="arrayEleOperation[index].INCOGNITA">
                  <option value="-3">Milésimas</option>
                  <option value="-2">Centésimas</option>
                  <option value="-1">Décimas</option>
                  <option value="0">Unidad</option>
                  <option value="1">Decena</option>
                  <option value="2">Centena</option>
                  <option value="3">U.millar</option>
                  <option value="4">D.millar</option>
                  <option value="5">C.millar</option>
                  <option value="6">U.millón</option>
                  <option value="7">D.millón</option>
                  <option value="8">C.millón</option>
                </select>
                <span class="validation-error">{{ errors[0] }}</span>
                 </ValidationProvider>
              </b-col>
          </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('decimal', {
  validate(value) {
    const f = parseFloat(value);
    const valid = !Number.isNaN(f);
    return valid && f >= 0;
  },
  message: 'Decimal positivo con "."',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      bShowLatex: false,
      arrayEleOperation: [],
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        ID: -1,
        TIPO_ACTIVIDAD: 1,
        ARABIGO: true,
        VERBAL_ORAL: false,
        VERBAL_ESCRITO: false,
        REPRESENTACION_GRAFICA: true,
        TIPO_REPRESENTACION: 2,
        MOSTRAR_DESCOMPUESTO: false,
        RESP_VERBAL_ORAL: true,
        RESP_VERBAL_ESCRITO: true,
        RESP_REPRESENTACION_GRAFICA: true,
        RESP_TIPO_REPRESENTACION: 2, //
        INDICATIVO_UNIDAD: true, //
        AUDIO_POR_ACTIVIDAD: true,
        SIMPLIFICAR_RESULTADO: true,
        EJERCICIOS_ID: -1, //
        IMAGENES_ID: 0,
        IMAGENES_ID_RESP: 0,
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        CANTIDAD: null,
        INCOGNITA: null,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('decimalnumeration/getdecimalnumeration', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            CANTIDAD: element.CANTIDAD,
            INCOGNITA: element.INCOGNITA,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
